import { render, staticRenderFns } from "./ManagementHistoryIndex.vue?vue&type=template&id=59e215c6&scoped=true&"
import script from "./ManagementHistoryIndex.vue?vue&type=script&lang=js&"
export * from "./ManagementHistoryIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e215c6",
  null
  
)

export default component.exports